export const disablePickingLine = async ({ id, articleStatus }) => {
    const requestPath = process.env.REACT_APP_APPSTATEMENT !== "development" ? process.env.REACT_APP_BASEURL_PRODUCTION : process.env.REACT_APP_BASEURL_DEVELOPING
    const resultDisablePickingLine = await window.fetch(`${requestPath}/back/routes/sqlPicking.php`, {
        method: 'PUT',
        body: JSON.stringify({ id, articleStatus })
    })

    const { result, message, error_msg } = await resultDisablePickingLine.json()
    return { result, message, error_msg }
}